/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { DOCUMENT } from "@angular/common";
import { Component, inject, Input, OnChanges, SimpleChanges } from "@angular/core";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { COLORS } from "../../utils/constants";

@Component({
	selector: "globalictcc-progress-bar",
	standalone: true,
	imports: [MatProgressBarModule],
	templateUrl: "./progress-bar.component.html",
	styleUrl: "./progress-bar.component.scss"
})
export class ProgressBarComponent implements OnChanges {
	@Input() public percentage: number = 0;
	@Input() public color: string = COLORS.GREEN;

	private readonly _document: Document = inject(DOCUMENT);

	ngOnChanges(changes: SimpleChanges) {
		const { color } = changes;

		if (color && color.currentValue) {
			this._document.documentElement.style.setProperty(
				"--mdc-linear-progress-active-indicator-color",
				color.currentValue,
				"important"
			);
		}
	}
}
